var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOldRelease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.597,
    height: 21.418,
    viewBox: "0 0 18.597 21.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cdd4dc",
    d: "M3.615-.422a3.25,3.25,0,1,1-3.25,3.25A3.25,3.25,0,0,1,3.615-.422Z",
    transform: "translate(11.632 15.24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9d1da",
    stroke: "#fff",
    strokeWidth: "0.2px",
    d: "M9.749,20.115H.657a.68.68,0,0,1-.657-.7V2.938a.679.679,0,0,1,.657-.7H16.163a.68.68,0,0,1,.657.7V12.4a6.026,6.026,0,0,0-1.314-.156v-8.6H1.314V18.721H9.469a5.982,5.982,0,0,0,.28,1.394Zm-2.235-5.13H3.757a.7.7,0,0,1,0-1.4H7.514a.7.7,0,0,1,0,1.4Zm5.137-3.464H3.645a.7.7,0,0,1,0-1.4h9.006a.7.7,0,0,1,0,1.4Zm0-3.417H3.806a.7.7,0,0,1,0-1.4h8.845a.7.7,0,0,1,0,1.4ZM12.836,1.4H3.991A.68.68,0,0,1,3.334.7.68.68,0,0,1,3.991,0h8.845a.68.68,0,0,1,.657.7A.679.679,0,0,1,12.836,1.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldRelease);
export default __webpack_public_path__ + "static/media/oldRelease.a6f530aa.svg";
export { ForwardRef as ReactComponent };